<script>
    export let links = [];
    export let title = '';

    export let classes = "pl-lg-4"
</script>

<div class="{classes}">
    <h5 class="p-0 m-0 mb-2 font-weight-bold">{title}</h5>
    <ul class="list-unstyled p-0 m-0 flex-wrap">
        {#each links as link}
            {#if link.title && link.url}
                <li class="mb-3">
                    <a href="{link.url}" target="_blank">{link.title}</a>
                </li>
            {/if}
        {/each}
    </ul>
</div>
